import { TicketingEvent } from '@wbk/api';
import { parseDate } from '@wbk/utils';

export const getEventStatus = (
  event: TicketingEvent,
  locale?: string
): {
  message:
    | 'more_details'
    | 'no_tickets_available'
    | 'sold_out'
    | 'sales_ended'
    | 'buy_tickets'
    | 'buy_stream';
  disabled: boolean;
} => {
  const tickets = event.event_tickets;
  const external_links = event?.tickets_external_link?.[locale || ''];

  if (external_links) {
    return {
      message: 'more_details',
      disabled: false,
    };
  }

  if (tickets.length <= 0)
    return {
      message: 'no_tickets_available',
      disabled: true,
    };

  if (tickets.every((ticket) => ticket.sold_out || ticket.remaining <= 0)) {
    return {
      message: 'sold_out',
      disabled: true,
    };
  }

  if (tickets.every((ticket) => ticket.sale_status === 'past')) {
    return {
      message: 'sales_ended',
      disabled: true,
    };
  }

  return {
    message: 'buy_tickets',
    disabled: false,
  };
};

export const canDownloadOrderTicket = (props: {
  send_tickets_date?: string;
  send_tickets_later?: 'yes' | 'no';
}) => {
  const downloadDate = props?.send_tickets_later === 'yes' ? props?.send_tickets_date : '';
  if (!downloadDate) return true;

  const date = new Date(parseDate(downloadDate));
  // If now >= downloadDate show download
  return Date.now() >= date.getTime();
};
